import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 flex w-full fixed h-screen items-center justify-center",
  style: {'left': '0px'}
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Change Email")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, "After you change your Email, next time you need to login with the new one.", -1)
const _hoisted_9 = { class: "pwd" }
const _hoisted_10 = ["type", "rules"]
const _hoisted_11 = { class: "p-viewer" }
const _hoisted_12 = { class: "flex justify-end" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Update", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "modal-button-close"
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.NewEmail) = $event)),
          type: "email",
          placeholder: "New Email Address",
          class: "form-field"
        }, null, 512), [
          [_vModelText, _ctx.NewEmail]
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Password) = $event)),
            class: "form-field",
            type: _ctx.passwordFieldType,
            rules: _ctx.passwordRules,
            placeholder: "Password"
          }, null, 8, _hoisted_10), [
            [_vModelDynamic, _ctx.Password]
          ]),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.sortHidden,
              onClick: _ctx.switchVisibility
            }, null, 8, ["icon", "onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args))),
            class: "button"
          }, _hoisted_14)
        ])
      ])
    ])
  ]))
}